import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function AppChrome({ v }: { v: Vals }) {
  return (
    <>
      <button onClick={v.kOpenAlerts} style={sx("position:absolute;top:66px;right:70px;z-index:8;width:40px;height:40px;border:none;padding:0;border-radius:var(--radius-full);background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:var(--shadow-md)")}>
        <span style={sx("width:20px;height:20px;background:var(--text-primary);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
        {v.kHasUnread ? (
          <>
            <span style={sx("position:absolute;top:-2px;right:-2px;min-width:18px;height:18px;padding:0 5px;border-radius:var(--radius-full);background:var(--bg-critical);color:#fff;font-size:var(--fs-2xs);font-weight:var(--fw-medium);display:flex;align-items:center;justify-content:center;border:2px solid var(--bg-primary)")}>
              {v.kUnread}
            </span>
          </>
        ) : null}
      </button>
      <button onClick={v.kProfileOpen} style={sx("position:absolute;top:66px;right:20px;z-index:8;width:40px;height:40px;border:none;padding:0;border-radius:var(--radius-full);background:var(--chart-6);color:#fff;font-family:inherit;font-size:var(--fs-sm);font-weight:var(--fw-medium);cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:var(--shadow-md)")}>
        V
      </button>
    </>
  )
}
